import * as XLSX from "xlsx";

type DeputyReportRow = {
  number?: number;
  control_number: string;
  fname: string;
  lname: string;
  total: number;
  endorser?: string | null;
};

type Filters = {
  year: number;
  search: string;
  endorser: string | null;
  dateRange: [string, string];
};

export const exportDeputyReportSummaryExcel = (
  data: DeputyReportRow[],
  filters: Filters
) => {
  const rows = data.map((row, index) => ({
    "#": index + 1,
    "Control No.": row.control_number || "—",
    Deputy: `${row.lname || ""}, ${row.fname || ""}`.trim() || "—",
    Total: Number(row.total ?? 0),
    Endorser: row.endorser || "—",
  }));

  const metaRows = [
    ["Deputy Report Summary"],
    ["For Board Review and Monitoring"],
    [],
    ["Year Registered", filters.year, "", "Period", `${filters.dateRange[0]} to ${filters.dateRange[1]}`],
    ["Endorser", filters.endorser ?? "All", "", "Search", filters.search || "—"],
    ["Total Deputies", data.length, "", "Generated On", new Date().toLocaleString()],
    [],
  ];

  const tableHeader = [["#", "Control No.", "Deputy", "Total", "Endorser"]];
  const tableRows = rows.map((row) => [
    row["#"],
    row["Control No."],
    row["Deputy"],
    row["Total"],
    row["Endorser"],
  ]);

  const footerRow: never[] = [];
  const generatedRow = [["Generated on", new Date().toLocaleDateString()]];

  const worksheetData = [
    ...metaRows,
    ...tableHeader,
    ...tableRows,
    footerRow,
    ...generatedRow,
  ];

  const ws = XLSX.utils.aoa_to_sheet(worksheetData);

  ws["!cols"] = [
    { wch: 8 },
    { wch: 18 },
    { wch: 32 },
    { wch: 10 },
    { wch: 38 },
  ];

  const mergeRanges = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } },
  ];
  ws["!merges"] = mergeRanges;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Deputy Summary");

  XLSX.writeFile(wb, `Deputy_Report_Summary_${filters.year}.xlsx`);
};
